var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8778 1.84375H2.82773C2.33068 1.84375 1.92773 2.24669 1.92773 2.74375V25.2952C1.92773 25.9693 2.64134 26.4041 3.24034 26.0951L12.1294 21.5096C12.3926 21.3738 12.7059 21.3762 12.967 21.5161L21.4528 26.0623C22.0523 26.3835 22.7778 25.9492 22.7778 25.269V2.74375C22.7778 2.24669 22.3748 1.84375 21.8778 1.84375Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/IconSave.81966b22de35ec9dd28e6b1218e16d8d.svg";
export { ForwardRef as ReactComponent };